/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.8",
    versionName: "0.2.0-nightly.2025.10.8",
    versionChannel: "nightly",
    buildDate: "2025-10-08T00:07:30.943Z",
    commitHash: "8d05844bbc99c3479182c77ba59f6f4f9b6c1e66",
};
